import {connect} from "react-redux";
import PaymentRaiseV2 from "./PaymentRaiseV2";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../../services/redux/fileUpload/action";
import {
    loanPaymentRaiseRequest,
    loanAccountRequest,
    loanUndertakingRequest,
    bankListRequest,
    loanTranchesRequest,
    loanPaymentRaiseUpdateRequest,
    loanApplicationByIdRequest,
    newBankDetailsRequest,
    loanApprovalRequestRequest,
    foreClosureAddAccountRequest
} from "../../../../../services/redux/CarLoan/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    bankListResponse: state.CarLoan.bankListResponse,
    loanApplicationUpdateResponse: state.CarLoan.loanApplicationUpdateResponse,
    loanAccountResponse: state.CarLoan.loanAccountResponse,
    loanUndertakingResponse: state.CarLoan.loanUndertakingResponse,
    loanPaymentRaiseUpdateResponse: state.CarLoan.loanPaymentRaiseUpdateResponse,
    ucdCaseByIdResponse: state.CarLoan.loanApplicationByIdResponse,
    loanTranchesResponse: state.CarLoan.loanTranchesResponse,
    loanPaymentRaiseResponse: state.CarLoan.loanPaymentRaiseResponse,
    newBankDetailsResponse : state.CarLoan.newBankDetailsResponse,
    loanApprovalRequestResponse : state.CarLoan.loanApprovalRequestResponse,
    foreClosureAddAccountResponse : state.CarLoan.foreClosureAddAccountResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            bankListRequest,
            loanUndertakingRequest,
            loanAccountRequest,
            loanPaymentRaiseRequest,
            loanTranchesRequest,
            loanPaymentRaiseUpdateRequest,
            loanApplicationByIdRequest,
            newBankDetailsRequest,
            loanApprovalRequestRequest,
            foreClosureAddAccountRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PaymentRaiseV2);
